import { useForm, FormProvider, useWatch } from 'react-hook-form';
import { TextField, SelectTag } from '../../../../../components';
import { Typography, Stack, Button, Grid } from '@mui/material';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect } from 'react';
import { GENDER_DROPDOWN, AGE_TYPE } from '../../../../../constants';

export const LisTestItemRefrenceRangeForm = ({ onClose, onAdd }) => {
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        // gender: Yup.string().required(' '),
        // type: Yup.string().required(' ')
      })
    ),
    mode: 'all'
  });
  const { handleSubmit, reset, setValue, control } = methods;

  const type = useWatch({
    control,
    name: 'type'
  });

  const ageFrom = useWatch({
    control,
    name: 'age_from'
  });

  const ageTo = useWatch({
    control,
    name: 'age_to'
  });

  useEffect(() => {
    const calculateDays = (value, type) => {
      if (!value) return 0;
      switch (type) {
        case 'Y':
          return value * 365;
        case 'M':
          return value * 30;
        case 'D':
          return value;
        default:
          return 0;
      }
    };

    if (type) {
      const ageFromInDays = calculateDays(Number(ageFrom), type);
      setValue('age_from_in_days', ageFromInDays);

      const ageToInDays = calculateDays(Number(ageTo), type);
      setValue('age_to_in_days', ageToInDays);
    }
  }, [type, ageFrom, ageTo, setValue]);

  const formSubmitHandler = (formValues) => {
    onAdd({ ...formValues, _id: Date.now().toString() });
    reset();
    console.log('Form Values:', formValues);
  };

  return (
    <FormProvider {...methods} onSubmit={handleSubmit(formSubmitHandler)}>
      <form onSubmit={handleSubmit(formSubmitHandler)}>
        <Typography
          sx={{ flex: 0.4, fontSize: '24px', fontWeight: 'bold', textAlign: 'center', backgroundColor: '#B0C4DE' }}
        >
          Add Age Wise Refrence Range
        </Typography>
        <Grid container spacing={1} sx={{ p: 1.5, minWidth: '70rem' }}>
          <Grid item xs={6} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
            <Stack spacing={0.5} direction="row" alignItems="center">
              <Typography sx={{ flex: 0.4 }}>Gender</Typography>
              <SelectTag formControlSX={{ flex: 1 }} name="gender" menus={GENDER_DROPDOWN} />
            </Stack>
            <Stack spacing={0.5} direction="row" alignItems="center">
              <Typography sx={{ flex: 0.4 }}>Age From</Typography>
              <TextField sx={{ flex: 1 }} name="age_from" />
            </Stack>
            <Stack spacing={0.5} direction="row" alignItems="center">
              <Typography sx={{ flex: 0.4 }}>Age From(in Days)</Typography>
              <TextField disabled sx={{ flex: 1 }} name="age_from_in_days" />
            </Stack>
            <Stack spacing={0.5} direction="row" alignItems="center">
              <Typography sx={{ flex: 0.4 }}>Range From </Typography>
              <TextField sx={{ flex: 1 }} name="range_from" />
            </Stack>
            <Stack spacing={0.5} direction="row" alignItems="center">
              <Typography sx={{ flex: 0.4 }}>Cric Range From </Typography>
              <TextField sx={{ flex: 1 }} name="cric_range_from" type="number" />
            </Stack>
          </Grid>
          <Grid item xs={6} sx={{ display: 'flex', flexDirection: 'column', gap: 0.3 }}>
            <Stack spacing={0.5} direction="row" alignItems="center">
              <Typography sx={{ flex: 0.4 }}>Type</Typography>
              <SelectTag formControlSX={{ flex: 1 }} name="type" menus={AGE_TYPE} />
            </Stack>
            <Stack spacing={0.5} direction="row" alignItems="center">
              <Typography sx={{ flex: 0.4 }}>Age To</Typography>
              <TextField sx={{ flex: 1 }} name="age_to" type="number" />
            </Stack>
            <Stack spacing={0.5} direction="row" alignItems="center">
              <Typography sx={{ flex: 0.4 }}>Age To(in Days)</Typography>
              <TextField disabled sx={{ flex: 1 }} name="age_to_in_days" />
            </Stack>
            <Stack spacing={0.5} direction="row" alignItems="center">
              <Typography sx={{ flex: 0.4 }}>Range</Typography>
              <TextField sx={{ flex: 1 }} name="range_to" />
            </Stack>
            <Stack spacing={0.5} direction="row" alignItems="center">
              <Typography sx={{ flex: 0.4 }}>Range </Typography>
              <TextField sx={{ flex: 1 }} name="cric_range_to" type="number" />
            </Stack>
          </Grid>
          <Grid item xs={12}>
            <Stack spacing={1} direction="row" alignItems="center">
              <Typography sx={{ flex: 0.8 }}>Ref. Range In Text </Typography>
              <TextField
                label="Description"
                multiline
                rows={4}
                variant="outlined"
                fullWidth
                placeholder="Enter your text here..."
                name="ref_range_in_text"
              />
            </Stack>
          </Grid>
          <Grid item xs={12}>
            <Stack spacing={0.5} direction="row" alignItems="center" justifyContent="end">
              <Button size="small" color="error" onClick={onClose}>
                Cancel
              </Button>
              <Button size="small" variant="contained" type="submit">
                Add
              </Button>
            </Stack>
          </Grid>
        </Grid>
      </form>
    </FormProvider>
  );
};
